<template>
	
  <Button :label="$t('details.buttons.cycle_start_button')" class="p-button-secondary p-m-2" @click="start" :disabled="disabled"/>


  <Dialog v-model:visible="dialog.select" class="irinox-dialog-light" :modal="true" 
      :closable="true" :dismissableMask="true" :draggable="false" style="width: 500px;">

    <template #header>
      
      <img v-if="step>1" src="assets/irinox/icons/arrow_back.svg" @click="() => step-- " :alt="$t('common.arrow_left')"/>
      
      <div v-if="step==1">{{$t('mya.category_header')}}</div>
      <div v-if="step==2">{{$t('mya.subcategory_header')}}</div>
      <div v-if="step==3">{{$t('mya.cycle_header')}}</div>

    </template>
    
      <div class="mya-start-cycle">
        
        <div v-if="step==1">
          <div v-for="(value, key) in cycles" @click="selectCategory(key)" :key="'cat_'+key">
            {{$t('mya.categories.'+key)}}
          </div>
        </div>
      
        <div v-if="step==2 && category">
          <div v-for="(value, key) in cycles[category]" @click="selectSubcategory(key)" :key="'cat_'+category+'_sub_'+key">
            {{$t('mya.subcategories.'+key)}}
          </div>
        </div>
      
        <div v-if="step==3 && category && subcategory">
          <div v-for="cycle in cycles[category][subcategory]" @click="selectCycle(cycle)" :key="'cat_'+category+'_sub_'+subcategory+'_cyc_'+cycle">
            {{$t('mya.cycles.'+cycle)}}
          </div>
        </div>

      </div>

    <template #footer>
    </template>
  </Dialog>

  <!--                -->
  <!-- START DIALOG -->
  <!--                -->
  <IrinoxDialogDark :visible="dialog.start" 
    mode="confirm" 
    :leftB="$t('mya.start_dialog_cancel_button')" 
    @click:left-button="()=>{dialog.start=!dialog.start}" 
    :rightB="$t('mya.start_dialog_ok_button')" 
    @click:right-button="startCycle" 
    :message="$t('mya.start_dialog')"
    icon="assets/irinox/icons/play_big.svg" />

  <!--                    -->
  <!-- ERRORS and SUCCESS -->
  <!--                    -->
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('details.mya.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.success" 
    mode="success" 
    :message="$t('details.mya.dialog_success')"
    :life="3000" 
    @update:visible="dialog.success = $event" />

</template>

<script>
import { mapGetters } from 'vuex';
import commands from "../../../../public/json/commands_mf.json"
import cycles from "../../../../public/json/cycles_mya.json"
import IrinoxDialogDark from '../../IrinoxDialogDark.vue';
import EventHubListenerService from '../../../service/EventHubListenerService';

export default {
    components: {
      IrinoxDialogDark
    },
    props: {
      serialNumber: String
    },
    data() {
        return {
          commands: commands,
          cycles: cycles,
          dialog: {
            select: false,
            start: false,
            success: false,
            error: false
          },
          step: 1,
          category: null,
          subcategory: null,
          cycle: null,
          disabled: true
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          deviceTwin: 'appliances/deviceTwin',
        }),
        appliance: function() {
            return this.$store.getters['appliances/appliance'](this.serialNumber);
        }
    },
    watch: {
      'deviceTwin.status.cycleRunning': 'updateDisabled',
      'appliance.online': 'updateDisabled',
      'appliance.disableCycleRunning': 'updateDisabled',
    },
    created() {
      this.eventHubListenerService = new EventHubListenerService();
    },
    mounted() {
      this.updateDisabled();
    },
    methods: {
      updateDisabled() {
        this.disabled = !this.appliance.online || this.appliance.disableCycleRunning || (this.deviceTwin && this.deviceTwin.status && this.deviceTwin.status.cycleRunning === 1);
      },
      start() {
        if(this.disabled) {
          return;
        }
        this.step = 1;
        this.category = null;
        this.subcategory = null;
        this.dialog.select = true;
      },
      selectCategory(key) {
        this.category = key;
        this.step = 2;
      },
      selectSubcategory(key) {
        this.subcategory = key;
        this.step = 3;
      },
      selectCycle(cycle) {
        this.cycle = cycle;
        this.dialog.select = false;
        this.dialog.start = true;
      },
      startCycle() {
        let data = {
          id: this.serialNumber+"_"+this.cycle,
          operationSet: 1
        };

        this.dialog.start = false;
        this.eventHubListenerService.postStartStop(this.personaltoken, this.serialNumber, data)
          .then((data) => {
            if(data.code=="200") {
              this.dialog.success = true;
            } else {
              console.error("EXCEPTION "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      }
    }
}
</script>

<style scoped>


</style>